<template>
  <div class="deletion-group-modal">
    <common-modal
      :name="modalName"
      :title="modalTitle"
      :primaryAction="modalPrimaryAction"
      :secondaryActions="modalSecondaryActions"
      height="auto"
    >
      <template #modal-body>
        <div class="md-layout">
          <div class="md-layout-item md-size-100 mt-2">
            <p class="text-gray-600 text-lg">
              {{ $t("schedule.confirm_cancel") }}
            </p>
          </div>
        </div>
      </template>
    </common-modal>
  </div>
</template>

<script>
import { getId, Message } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";

export default {
  props: ["selectedEvent"],
  data() {
    return {
      modalName: "cancelVCREvent",
      modalTitle: this.$t("schedule.cancel_event"),
      modalPrimaryAction: {
        title: this.$t("schedule.confirm"),
        action: this.cancelEvent,
        class: "md-danger"
      },
      modalSecondaryActions: [
        {
          title: this.$t("common.cancel"),
          action: () => {
            this.hide();
          }
        }
      ]
    };
  },
  inject: ["refetchEvents"],
  computed: {
    eventId() {
      const eventData = this.selectedEvent?.event;
      return getId(eventData?.extendedProps);
    }
  },
  methods: {
    hide() {
      this.$modal.hide(this.modalName);
    },
    open() {
      this.$modal.show(this.modalName);
    },
    cancelEvent() {
      this.$axios
        .post(
          `${service_paths.calendars}/${this.eventId}/cancel-video-conference`
        )
        .then(() => {
          this.$emit("close-detail-modal");
          this.hide();
          Message.success(this.$t("schedule.cancel_meeting_successfully"));
          this.refetchEvents();
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
